<script>
export default {
  name: "SearchIcon",
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <circle
      cx="11.5"
      cy="11.5"
      r="9.5"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M18.5 18.5L22 22"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<style scoped lang="scss"></style>
